import { insertIdToArray } from "components/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { deleteFileServ, fetchAlertsService, getAnomaliesService, getBlockChainBlockServ, getBlockChainServ, getDashboardAnalyticsServ, getDeviceUsersServ, getFilesServ, getFimServ, getMalwareHashesServ } from "../services/single.service";
import { alertsActions } from "../slice/alerts.slice";
import { anomaliesActions } from "../slice/anomalies.slice";
import { applicationsActions } from "../slice/applications.slice";
import { blockChainActions } from "../slice/blockchain.slice";
import { deviceUsersActions } from "../slice/deviceUsers.slice";
import { filesActions } from "../slice/files.slice";
import { fimActions } from "../slice/fim.slice";
import { networksActions } from "../slice/networks.slice";
import { packagesActions } from "../slice/packages.slice";
import { portsActions } from "../slice/ports.slice";
import { processesActions } from "../slice/processes.slice";
import { systemActions } from "../slice/system.slice";
import { FETCH_ALERTS, GET_BLOCKCHAIN_BLOCK, GET_BLOCKCHAIN_INFO, GET_DEVICE_ANOMALIES, GET_MALWARE_HASHES } from "../types/devices.types";
import { DELETE_FILE, GET_DASHBOARD_ANALYTICS, GET_DEVICE_USERS, GET_FILES, GET_FIM } from "../types/shared.types";


export function* getDashboardAnalytics(action) {
    try {
        const response = yield getDashboardAnalyticsServ(action.payload)
        if (response) {
            yield put(applicationsActions.actions.setApplications(insertIdToArray(response?.applications?.result)));
            yield put(applicationsActions.actions.setCombineApps(insertIdToArray(response?.combinedApps?.result)));
            yield put(networksActions.actions.setNetworks(insertIdToArray(response?.networks?.result)));
            yield put(packagesActions.actions.setPackages(insertIdToArray(response?.packages?.result)));
            yield put(portsActions.actions.setPorts(insertIdToArray(response?.ports?.result)));
            yield put(processesActions.actions.setProcesses(insertIdToArray(response?.processes?.result)));
            yield put(systemActions.actions.setSystem(response?.system?.result));
        }
        else {
            yield put(applicationsActions.actions.setApplications([]));
            yield put(applicationsActions.actions.setCombineApps([]));
            yield put(networksActions.actions.setNetworks([]));
            yield put(packagesActions.actions.setPackages([]));
            yield put(portsActions.actions.setPorts([]));
            yield put(processesActions.actions.setProcesses([]));
            yield put(systemActions.actions.setSystem({}));
        }
    } catch (err) {
        console.log("err", err);
    }
}

export function* getFiles(action) {
    try {
        const response = yield getFilesServ(action.payload)
        if (response) {
            yield put(filesActions.actions.setFiles(response));
        }
        else {

        }
    } catch (err) {
        console.log("err", err);
    }
}

export function* getFim(action) {
    try {
        const response = yield getFimServ(action.payload)
        if (response) {
            yield put(fimActions.actions.setFim(insertIdToArray(response?.["Events:"])));
        }
        else {
            yield put(fimActions.actions.setFim([]));
        }
    } catch (err) {
        console.log("err", err);
    }
}

export function* deleteFile(action) {
    try {
        const response = yield deleteFileServ(action.payload)
        if (response) {
            const files = yield select(filesActions.selectors.getFiles);
            const updatedFiles = files?.filter((file) => file?._id !== action?.payload?.fileId);
            yield put(filesActions.actions.setFiles(updatedFiles));
        }
        else {

        }
    } catch (err) {
        console.log("err", err);
    }
}

export function* getDeviceUsers(action) {
    try {
        const response = yield getDeviceUsersServ(action.payload);
        if (response) {
            yield put(deviceUsersActions.actions.setdeviceUsers(insertIdToArray(response?.data?.result)));
        }
        else {
            yield put(deviceUsersActions.actions.setdeviceUsers([]));
        }
    } catch (err) {
        console.log("err", err);
    }
}

export function* getMalwareHashes(action) {
    try {
        yield put(applicationsActions.actions.setMalwareSearchLoader(true));
        const response = yield getMalwareHashesServ(action.payload);
        if (response?.data) {
            yield put(applicationsActions.actions.setMalwareApps(response?.data));
        }
        else {
            yield put(applicationsActions.actions.setMalwareApps({}));
        }
        yield put(applicationsActions.actions.setMalwareSearchLoader(false));
    } catch (err) {
        console.log("err", err);
    }
}

function* fetchAlertsSaga(action) {
    try {
        const response = yield call(fetchAlertsService, action.payload);
        yield put(alertsActions.actions.setAlerts(insertIdToArray(response?.result)))
    } catch (error) {
    }
}

function* getBlockChainData() {
    try {
        const response = yield getBlockChainServ();
        if (response?.data) {
            yield put(blockChainActions.actions.setBlockChain(response?.data?.blocks));
        }
        else {
            yield put(blockChainActions.actions.setBlockChain({}));
        }
    } catch (err) {
        console.log("err", err);
    }
}

function* getBlockChainBlock(action) {
    try {
        const response = yield getBlockChainBlockServ(action.payload);
        if (response?.data) {
            yield put(blockChainActions.actions.setBlockChainBlock(response?.data));
        }
        else {
            yield put(blockChainActions.actions.setBlockChainBlock({}));
        }
    } catch (err) {
        console.log("err", err);
    }
}


function* getAnomaliesSaga(action) {
    try {
        const response = yield call(getAnomaliesService, action.payload);
        console.log("response", response)
        yield put(anomaliesActions.actions.setAnomalies(insertIdToArray(response?.data?.result)))
    } catch (error) {
    }
}

export function* watchSingleAsync() {
    yield takeEvery(GET_DASHBOARD_ANALYTICS, getDashboardAnalytics);
    yield takeEvery(GET_FILES, getFiles);
    yield takeEvery(DELETE_FILE, deleteFile);
    yield takeEvery(GET_FIM, getFim);
    yield takeEvery(GET_DEVICE_USERS, getDeviceUsers);
    yield takeEvery(FETCH_ALERTS, fetchAlertsSaga);
    yield takeEvery(GET_MALWARE_HASHES, getMalwareHashes);
    yield takeEvery(GET_BLOCKCHAIN_INFO, getBlockChainData);
    yield takeEvery(GET_BLOCKCHAIN_BLOCK, getBlockChainBlock);
    yield takeEvery(GET_DEVICE_ANOMALIES, getAnomaliesSaga);
}